 export const descriptionSuite = () => {
     return (
        <div>
          
  <h3>Location de fauteuil roulant – courte durée</h3>
  <p><em>(applicable depuis le 1er décembre 2025)</em></p>

  <p>
    La location courte durée de fauteuils roulants est prise en charge dans le cadre du
    <strong> 100 % Santé</strong>. Cette prise en charge est hebdomadaire et limitée à <strong> 13 semaines</strong>, avec la possibilité d’un <strong>renouvellement unique </strong>
    pour une durée équivalente, dans la limite de <strong>6 mois au total</strong>.
  </p>

  <p>
    Votre contrat complémentaire prend en charge la différence entre la base de remboursement
    de l'Assurance maladie et le prix limite de vente, de sorte qu’ <strong>aucun reste à charge</strong> ne vous est appliqué.
  </p>

  <p>
    <strong>À noter :</strong> Lorsque les conditions de prise en charge sont respectées,
    l'achat et la location longue durée de fauteuils roulants sont intégralement pris en charge
    par l'Assurance maladie, sans intervention de votre complémentaire.
  </p>

  <hr />

  <h3>Prothèses capillaires – Classe II</h3>
  <p><em>(applicable depuis le 1er janvier 2026)</em></p>

  <p>
    Les prothèses capillaires de classe II sont des prothèses capillaires totales constituées
    d'au moins <strong>30 % de cheveux naturels</strong>, ou de fibres synthétiques implantées
    exclusivement à la main sur une surface supérieure à <strong>100 cm²</strong>.
  </p>

  <p>
    Elles sont prises en charge intégralement
    (<strong>Assurance maladie + complémentaire santé</strong>),
    dans la limite du prix limite de vente.
  </p>

  <p>
    Cette prise en charge inclut également un <strong>accessoire textile </strong>
    (turban, foulard, bonnet ou autre tissu hypoallergénique).
  </p>
  <br />
  <p>Conditions à respecter :</p>
  <ul>
    <li>La prothèse doit faire l'objet d'une <strong>prescription médicale</strong> ;</li>
    <li>
      Lors de la première délivrance, la prothèse doit être
      <strong> essayée sur site</strong> auprès d'un distributeur qualifié
      (coiffeur, perruquier-posticheur ou professionnel de santé formé) ;
    </li>
    <li>
      La vente à distance sans essayage est réservée aux situations de
      <strong> renouvellement</strong> ;
    </li>
    <li>
      Le renouvellement de la prise en charge est possible après une période de
      <strong> 12 mois</strong> suivant la date de la prise en charge précédente.
    </li>
  </ul>

  <p>
    Pour toute question, contactez votre conseiller.
  </p>
        </div>
      );
  }


  export const title = '100 % Santé – De nouvelles prises en charge sur votre contrat';
  export const description = () => {
    return (
      <div>
        <p>
          Chers assurés,
        </p>
        <p>
          Le dispositif 100 % Santé évolue : votre contrat intègre désormais la prise en charge de la location courte durée de fauteuils roulants ainsi que des prothèses capillaires de classe II, sans reste à charge de votre part dans les limites et conditions prévues par la réglementation.
        </p>
      </div>
    )
  }